import React from 'react';
import { Link } from 'react-router-dom';
import { MultiLang } from '../config';

interface Props {
    lang: MultiLang;
}

const BMIOriginalContents: React.FC<Props> = (props: Props) => {
    return (
        <div className="bmiOriginalContents">
            <h1><img src={process.env.PUBLIC_URL + '/images/22.png'} alt="Original Contents" /></h1>
            <table>
                <tbody>
                    <tr>
                        <th colSpan={2}>
                            <img src={process.env.PUBLIC_URL + '/images/17.png'} alt="folder" />
                            Monkey brain atlas
                        </th>
                    </tr>
                    <tr>
                        <td className="preview"><img src={process.env.PUBLIC_URL + '/database/file/112.png'} alt="112" /></td>
                        <td className="content">
                            <Link to="/database/item/4318">Brain sections of monkeys, stained for AChE, ER81 mRNA and Sema3E mRNA</Link>
                            <br />
                            <ul>
                                <li>Picture</li>
                                <li>Akiya Watakabe (Yamamori lab)</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td className="preview">no image</td>
                        <td className="content">
                            <Link to="/database/item/4299">MRI Brain Atlas of Japanese "Snow" Monkey (Macaca Fuscata) at different ages</Link>
                            <br />
                            <ul>
                                <li>Picture</li>
                                <li>Masato TAIRA</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td className="preview"><img src={process.env.PUBLIC_URL + '/database/file/101.png'} alt="101" /></td>
                        <td className="content">
                            <Link to="/database/item/4300">The Stereotaxic MRI Brain Atlas of Japanese "Snow" Monkey</Link>
                            <br />
                            <ul>
                                <li>Picture</li>
                                <li>Masato TAIRA</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th colSpan={2}>
                            <img src={process.env.PUBLIC_URL + '/images/18.png'} alt="folder" />
                            Monkey M1 BMI
                        </th>
                    </tr>
                    <tr>
                        <td className="preview">no image</td>
                        <td className="content">
                            <Link to="/database/item/2143">m-file for training of wrist angle estimation</Link>
                            <br />
                            <ul>
                                <li>Other (Matlab)</li>
                                <li>Y.Koike</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td className="preview">no image</td>
                        <td className="content">
                            <Link to="/database/item/2144">m-file for checking the results of wrist angle estimation</Link>
                            <br />
                            <ul>
                                <li>Other (Matlab)</li>
                                <li>Y.Koike</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td className="preview"><img src={process.env.PUBLIC_URL + '/database/file/105.png'} alt="105" /></td>
                        <td className="content">
                            <Link to="/database/item/3124">M1 Neuronal Activity during monkey performing a motor task</Link>
                            <br />
                            <ul>
                                <li>Movie</li>
                                <li>Hirose H</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td className="preview">no image</td>
                        <td className="content">
                            <Link to="/database/item/3122">Muscle tension</Link>
                            <br />
                            <ul>
                                <li>Other (Matlab)</li>
                                <li>Y.Koike</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td className="preview">no image</td>
                        <td className="content">
                            <Link to="/database/item/3123">raw EMG signal</Link>
                            <br />
                            <ul>
                                <li>Other (Matlab)</li>
                                <li>Y.Koike</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td className="preview">no image</td>
                        <td className="content">
                            <Link to="/database/item/2145">training data of wrist angle and emg signal</Link>
                            <br />
                            <ul>
                                <li>Other (Matlab)</li>
                                <li>Y.Koike</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td className="preview">no image</td>
                        <td className="content">
                            <Link to="/database/item/2146">weight file of neural network</Link>
                            <br />
                            <ul>
                                <li>Other (Matlab)</li>
                                <li>Y.Koike</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th colSpan={2}>
                            <img src={process.env.PUBLIC_URL + '/images/25.png'} alt="folder" />
                            Multineuron activity in monkey prefrontal cortex
                        </th>
                    </tr>
                    <tr>
                        <td className="preview"><img src={process.env.PUBLIC_URL + '/database/file/106.png'} alt="106" /></td>
                        <td className="content">
                            <Link to="/database/item/4306">Multineuron activity in monkey prefrontal cortex recorded by 3 tetrodes.</Link>
                            <br />
                            <ul>
                                <li>Movie</li>
                                <li>Yoshio Sakurai</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th colSpan={2}>
                            <img src={process.env.PUBLIC_URL + '/images/26.png'} alt="folder" />
                            Cortical Box Method
                        </th>
                    </tr>
                    <tr>
                        <td className="preview"><img src={process.env.PUBLIC_URL + '/database/file/108.png'} alt="108" /></td>
                        <td className="content">
                            <Link to="/database/item/4313">Cortical Box Method</Link>
                            <br />
                            <ul>
                                <li>Program</li>
                                <li>Junya Hirokawa</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th colSpan={2}>
                            <img src={process.env.PUBLIC_URL + '/images/27.png'} alt="folder" />
                            fMRI visual image reconstruction
                        </th>
                    </tr>
                    <tr>
                        <td className="preview">no image</td>
                        <td className="content">
                            <Link to="/database/item/4332">fMRI data and program for visual image reconstruction</Link>
                            <br />
                            <ul>
                                <li>URL</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td className="preview">no image</td>
                        <td className="content">
                            <Link to="/database/item/4333">Reconstructed visual images from human fMRI activity</Link>
                            <br />
                            <ul>
                                <li>Picture</li>
                                <li>Yoichi Miyawaki</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <th colSpan={2}>
                            <img src={process.env.PUBLIC_URL + '/images/28.png'} alt="folder" />
                            Monkey M1 &amp; SMA single-unit activity
                        </th>
                    </tr>
                    <tr>
                        <td className="preview">no image</td>
                        <td className="content">
                            <Link to="/database/item/4341">Neuronal activity during performance of a memory-guided movement</Link>
                            <br />
                            <ul>
                                <li>PowerPoint</li>
                                <li>Toshi Nakajima</li>
                            </ul>
                        </td>
                    </tr>
                    <tr>
                        <td className="preview">no image</td>
                        <td className="content">
                            <Link to="/database/item/4342">Neuronal activity during performance of a memory-guided movement</Link>
                            <br />
                            <ul>
                                <li>Excel</li>
                                <li>Toshi Nakajima, Hajime Mushiake</li>
                            </ul>
                        </td>
                    </tr>

                </tbody>
            </table>
        </div>
    );
};

export default BMIOriginalContents;
